import {
  Component,
  Inject,
  PLATFORM_ID,
  OnInit
} from '@angular/core';
import { NotificationService } from '../../../../../services/notifications';
import { isPlatformBrowser, Location } from '@angular/common';
import { Router } from '@angular/router';

@Component({
  selector: 'app-usernotifications',
  templateUrl: './usernotifications.component.html',
  styleUrl: './usernotifications.component.scss'
})
export class UsernotificationsComponent implements OnInit {

  contentReady = true;
  noData = false;
  isAr = false;
  notifications: any[] = [];

  private isBrowser: boolean;

  constructor(
    private location: Location,
    private router: Router,
    private notificationService: NotificationService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  ngOnInit(): void {

    // language → browser only
    if (this.isBrowser) {
      this.isAr = localStorage.getItem('language') === 'ar';
    }

    this.loadNotifications();
  }
  goBack(): void {
    if (window.history.length > 1) {
      this.location.back();
    } else {
      this.router.navigate(['/Home']);
    }
  }
  // ================= DATA =================
  loadNotifications(): void {
    this.contentReady = true;

    this.notificationService.getAllNotifications().subscribe({
      next: (data) => {
        this.notifications = data || [];
        this.noData = this.notifications.length === 0;
        this.contentReady = false;
      },
      error: (err) => {
        console.error(err);
        this.noData = true;
        this.contentReady = false;
      },
    });
  }
}
